import styled from 'styled-components';
import { Row, Col, Button, Modal, Table, Tag } from 'antd';
import { RiskScale } from '@/styles/enum';
import { customReportPaletteMap } from '@/utils/get-risk-range';
import type { Theme } from '@/styles/themes/types';

type TagRiskProps = {
	$result: number;
	$isBrightBackground?: number;
};

export const TagRisk = styled(Tag)<TagRiskProps>`
	border-radius: 5px;
	background-color: ${({ $result, theme }) => setTagBackGroundColor(theme, $result)};
	span {
		color: ${({ $isBrightBackground, $result }) => ($isBrightBackground && $result !== 2 ? 'white' : 'black')};
	}
`;

export const TableContainer = styled(Col)`
	.ant-table {
		border-radius: 10px;
		.ant-table-thead {
			.ant-table-cell:first-child {
				border-radius: 10px 0 0 0;
			}
			.ant-table-cell:last-child {
				border-radius: 0 10px 0 0;
			}
		}
	}
`;

export const CustomButton = styled.div`
	&:hover {
		span {
			color: white;
		}
	}
`;

export const TableCustom = styled(Table)`
	.ant-table-selection-column {
		display: none;
	}
	.ant-table-content {
		table {
			border-spacing: 0 5px;
			background-color: #f0f2f5;
		}
		tr {
			background-color: #f0f2f5;
			border-radius: 10px;
		}
		.ant-table-cell {
			border-radius: 10px;
			background-color: #fff;
		}
		.ant-table-row-selected {
			.ant-table-cell {
				background-color: #eaeefd;
				border-radius: 10px;
				border: 2px solid #2f54eb;
			}
		}
	}
`;

export const ModalCustom = styled(Modal)`
	.ant-modal-content {
		min-height: 400px;
		height: 40vh;
		box-shadow: none;
		border-radius: 32px;
	}
	.ant-modal-body {
		margin: 0;
		padding: 0;
	}
`;

export const GeneralActions = styled(Row)`
	overflow: hidden;
	border-radius: 5px;

	.ant-col {
		background-color: #ffffff;

		&:nth-child(2) {
			border-left: 2px solid #f0f2f5;
			border-right: 2px solid #f0f2f5;
		}

		svg {
			font-size: 22px;
		}
	}

	.ant-btn-dangerous {
		color: #e74150;
	}
`;

function setTagBackGroundColor(theme: Theme, $result: RiskScale) {
	if ($result === 0) {
		return theme.colors.risk.low;
	}
	return customReportPaletteMap[$result] ?? theme.palette.secondary[250];
}

interface ButtonProps {
	selected?: boolean;
}

const COLOR_SELECTED = '#2F54EB';
const COLOR_UNSELECTED = '#000000';

const WrapperButton = styled(Button)`
	border: none;
	box-shadow: none;
	margin: 10px 5px;
	background-color: transparent;

	span {
		font-size: 23px !important;
	}

	&:hover {
		background-color: transparent;
	}
`;

export const HamburguerButton = styled(WrapperButton)<ButtonProps>`
	svg {
		fill: ${({ selected }) => (selected ? COLOR_SELECTED : COLOR_UNSELECTED)};
	}
`;

export const DetailedListButton = styled(WrapperButton)<ButtonProps>`
	color: ${({ selected }) => (!selected ? COLOR_SELECTED : COLOR_UNSELECTED)};

	svg {
		fill: ${({ selected }) => (!selected ? COLOR_SELECTED : COLOR_UNSELECTED)};
	}
`;
